module.exports = __webpack_public_path__ + "img/logo-instituto-prohemoce-iph.9ad66b3b.png";